module.exports = __webpack_public_path__ + "img/whiteIdentity.fe8e148e.svg";